import React, { FC } from "react"
import { Chip } from "./Chip";
import { 
  AnswerStatuses, AuthService, IMeetingConfirmation, 
  IUser, getMemberIcon, getShortUserName 
} from "../../../../../utils";

interface ReadOnlyChipProps {
  member: IUser;
  initiatorId: number;
  confirmations: IMeetingConfirmation[];
}

export const ReadOnlyChip: FC<ReadOnlyChipProps> = ({ member, initiatorId, confirmations }) => {
  const isInitiator = member.id === initiatorId;
  const isNowUser = member.id === AuthService.getUserId();
  
  return (
    <Chip
      label={isNowUser ? 'Вы' : getShortUserName(member.fullName)}
      remoteWorkIcon={isNowUser ? undefined : getMemberIcon(member, true, 'confirmation-round tooltip-question')}
      confirmationStatus={
        confirmations && member.id === initiatorId || isInitiator && !isNowUser
          ? AnswerStatuses.ACCEPTED
          : confirmations && confirmations.find((elem) => elem.userId === member.id)?.answerStatus
      }
    />
  )
}
